// extracted by mini-css-extract-plugin
export default {"support_main":"GovernmentSupport_support_main__w1j-Q"};